import { Button } from '@mui/material';
import React, { useState } from 'react';
import ApiClient from '../../config/ApiClient';

export type ProgramWeek = 4 | 8 | 12;

/** Body returned by POST .../growth-report/week/{n}/enqueue on success */
type EnqueueGrowthReportBody = {
    message?: string;
    success?: boolean;
    queue_id?: number;
    created?: boolean;
    requeued?: boolean;
};

export interface GrowthReportEnqueueButtonProps {
    paymentAssignmentId: number;
    week: ProgramWeek;
    onMessage: (message: string, severity: 'success' | 'error') => void;
}

const GrowthReportEnqueueButton: React.FC<GrowthReportEnqueueButtonProps> = ({
    paymentAssignmentId: pid,
    week,
    onMessage,
}) => {
    const [busy, setBusy] = useState(false);

    const labels: Record<ProgramWeek, string> = {
        4: 'Generate week 4 growth report',
        8: 'Generate week 8 growth report',
        12: 'Generate week 12 growth report',
    };

    const enqueue = async () => {
        setBusy(true);
        try {
            const res = await ApiClient.post<EnqueueGrowthReportBody>(
                `/api/payment-assignments/${pid}/growth-report/week/${week}/enqueue`,
                {}
            );
            if (res.success) {
                onMessage(res.data?.message || 'Growth report has been queued.', 'success');
            } else {
                onMessage(res.error || 'Could not queue growth report.', 'error');
            }
        } catch (err: any) {
            onMessage(err instanceof Error ? err.message : 'Could not queue growth report.', 'error');
        } finally {
            setBusy(false);
        }
    };

    return (
        <Button
            variant="outlined"
            size="small"
            disabled={busy}
            onClick={enqueue}
            data-testid={`enqueue-growth-report-week-${week}`}
            data-attr={`enqueue_growth_report_week_${week}`}
        >
            {busy ? 'Queueing…' : labels[week]}
        </Button>
    );
};

export default GrowthReportEnqueueButton;
